import { DataTestId, TextKey } from '@mews-distributor/common';
import { omitFalsyValues } from '@mews/fp';
import { LocalizedText } from '@mews/framework';
import { Checkbox } from '@optimus-web/core';
import { getEnterpriseName } from '../../../../modules/entities/enterprises/selectors';
import { localizeProperty } from '../../../../modules/globalization/selectors';
import { useAppSelector } from '../../../../utils/redux';

const id = 'reservation-sms-checkbox';

interface ReservationSmsProps {
    enterpriseId: string;
    checked: boolean | undefined;
    onChange: (event: React.SyntheticEvent<HTMLElement>, checked: boolean) => void;
}

export const ReservationSms = ({ checked, onChange, enterpriseId }: ReservationSmsProps) => {
    const enterpriseName = useAppSelector((state) => {
        const name = getEnterpriseName(state, { enterpriseId });
        return localizeProperty(state, { property: name });
    });

    return (
        <Checkbox
            checked={checked}
            onChange={onChange}
            id={id}
            name={id}
            data-test-id={DataTestId.ReservationSmsCheckbox}
        >
            <LocalizedText
                textKey={TextKey.SendMarketingEmailsConsentAgreement}
                substitutes={omitFalsyValues({ enterpriseName })}
            />
        </Checkbox>
    );
};
